import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/jobs/position.svg")